import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalInterceptor } from "@azure/msal-angular";
import { Observable } from "rxjs";
import { MsalAuthenticationService } from "../services/msal-authentication.service";

@Injectable()
/** Conditional MSAL Interceptor
 * This interceptor checks if the current entry point is an advisor SSO entry before applying the MSAL interceptor logic.
 * If it's not an advisor SSO entry, it simply forwards the request without adding any authentication headers.
 * This allows us to avoid unnecessary authentication attempts for non-SSO entry points, improving performance and user experience.
 */
export class ConditionalMsalInterceptor implements HttpInterceptor {
  constructor(
    private readonly msalAuthenticationService: MsalAuthenticationService,
    private readonly msalInterceptor: MsalInterceptor
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.msalAuthenticationService.isAdvisorSsoEntry()) {
      return next.handle(request);
    }

    return this.msalInterceptor.intercept(request, next);
  }
}
